import { render, staticRenderFns } from "./adminSelect.vue?vue&type=template&id=b94209f8&scoped=true&"
import script from "./adminSelect.vue?vue&type=script&lang=js&"
export * from "./adminSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b94209f8",
  null
  
)

export default component.exports